module.exports = __webpack_public_path__ + "static/media/HugeCarPark.6fb038eb.wav";